export default (text, size = 50) => `${text.slice(0, size)}...`;
